import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import ListItemText from '@material-ui/core/ListItemText';

// core components
import CustomInput from "components/CustomInput/CustomInput.js";

export default function ToggleInput(props) {
    const { edit, label, name, value, underlineColor, onChange, type, labelSize } = props;

    const typoProps = {
        primaryTypography: {
            variant: 'caption', color: 'textSecondary'
        },
        secondaryTypography: {
            variant: 'body1', color: 'textPrimary'
        },
        secondaryLargeTypography: {
            variant: 'h5', color: 'textPrimary'
        }
    }

    return (
        edit ?
            <CustomInput
                labelText={label} formControlProps={{ fullWidth: true }}
                underlineColor={underlineColor}
                inputProps={{
                    type: type, value: value,
                    onChange: (e) => { if (onChange) onChange(name, e.target.value) }
                }}
                labelProps={{ shrink: value !== undefined ? true : false }}
            /> :
            labelSize === "lg" ? 
                <ListItemText secondary={value} primary={label}
                    secondaryTypographyProps={typoProps.secondaryLargeTypography}
                    primaryTypographyProps={typoProps.primaryTypography} /> :
                <ListItemText secondary={value} primary={label}
                    secondaryTypographyProps={typoProps.secondaryTypography}
                    primaryTypographyProps={typoProps.primaryTypography} />
    );
}

const colors = [
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
];

ToggleInput.propTypes = {
    edit: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.any,
    underlineColor: PropTypes.oneOf(colors),
    onChange: PropTypes.func,
    type: PropTypes.string
};
